export default __webpack_public_path__ + "images/6686d9d1feb8b7678da5c23b775cdc72-tankBullet0.png";